import _ from "lodash";

import {amountInEuro, amountFromEuro, grossValue, ComputingAsset} from "@scriba/common";

import {Asset, Currency} from "../generated/graphql";

export const sumAssetValues = (assets: (ComputingAsset & Pick<Asset, 'currency'>)[], currency: Currency): number =>
  amountFromEuro(_.sum(assets.map(a => amountInEuro(grossValue(a), a.currency))), currency)
